import { createContext } from 'react';
import { StepperController } from 'src/hooks/components/use-paginated-stepper';

// distinct name from MUI stepper context
export const PaginatedStepperContext = createContext<
  StepperController | undefined
>(undefined);
